<template>
  <div
    ref="gallery"
    id="gallery"
    class="gallery"
    v-scroll-reveal.reset="vScrollOpts.left"
  >
    <div class="gallery-mobile" v-if="isMobile">
      <img
        v-for="image in filteredImages"
        :key="image"
        class="gallery-image-mobile"
        :src="image"
        alt="gallery-img.jpeg"
      />
    </div>
    <masonry v-else class="masonary" :cols="cols" :gutter="{ default: '5px' }">
      <img
        v-for="(image, i) in images"
        :style="{ paddingBottom: gutter.default }"
        :key="i"
        class="gallery-image"
        v-lazy="image.src || image.thumb"
        alt="gallery-img.jpeg"
        @click="styleAndOpenGallery(i, openGallery)"
      />
    </masonry>
    <LightBox
      ref="lightbox"
      :media="images"
      :show-caption="false"
      :show-light-box="false"
    />
  </div>
</template>

<script>
  import LightBox from 'vue-image-lightbox'
  import { mapState } from 'vuex'

  export default {
    name: 'Gallery',
    components: {
      LightBox
    },
    props: {
      filteredImages: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    data() {
      return {
        index: null,
        cols: { default: 3, 1000: 2, 900: 1 },
        items: [1, 2, 3, 4, 5],
        isMobile: false,
        gutter: { default: '5px' }
      }
    },
    computed: {
      ...mapState(['windowSize', 'vScrollOpts', 'styleBeforeLightbox']),
      images() {
        const images = this.filteredImages.map(image => {
          return {
            thumb: image,
            src: image
          }
        })
        return this.filteredImages ? images : []
      }
    },

    watch: {
      windowSize({ width, height }) {
        this.isMobile = width <= 500 ? true : false
        this.isMobile = height > 750 || width > 500 ? false : true
        this.cols =
          width < 450 && height > 750
            ? { default: 2 }
            : { default: 3, 1000: 2, 900: 1 }
      }
    },

    methods: {
      openGallery(index) {
        this.$refs.lightbox.showImage(index)
      },

      styleAndOpenGallery(index, cb) {
        this.$refs.gallery.style = this.styleBeforeLightbox
        cb(index)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gallery {
    overflow: scroll;
    flex-basis: 45%;
    display: flex;
    align-items: center;

    .gallery-mobile {
      display: flex;
      align-items: center;
    }

    .gallery-image-mobile,
    .gallery-image {
      background-size: cover;
      cursor: pointer;
    }

    .gallery-image-mobile {
      height: 185px;
      display: block;
    }
    .gallery-image {
      max-width: 250px;
      width: 100%;
      display: block;
    }
  }

  @include small-breakpoint {
    .gallery {
      display: block;
      flex-basis: 30%;
    }
  }

  @include large-breakpoint {
    .gallery {
      flex-basis: 40%;
    }
  }
</style>
